import * as IoC from 'inversify';
import { TrackingPlugin, TrackingPluginSymbol } from '../../tracking-api';
import * as Common from '../../common';
import { TinCanTrackingPlugin } from './plugin';
import { TinCanEventHandler } from './plugin/tincan-event-handler';
import { XApiClient, TinCanLaunchParametersResolver } from './client';
import { XApiSuspendDataStore } from './store';
import { examTinCanTrackingModules } from '@/app/exam/tracking/tincan/di';
import { sectionStateTinCanTrackingModules } from '@/app/section-state/tracking/tincan/di';
import { courseTinCanTrackingModule } from '@/app/course/tracking/tincan/di';
import { badgeTinCanTrackingModules } from '@/app/badge/tracking/tincan/di';
import { interactionTinCanTrackingModules } from '@/app/interaction/tracking/tincan/di';
import { questionTinCanTrackingModules } from '@/app/question/tracking/tincan/di';
import { bookmarkTinCanTrackingModules } from '@/app/bookmark/tracking/tincan/di';

export const tincanModule = new IoC.ContainerModule((bind) => {

  bind(XApiClient).toSelf().inSingletonScope();
  bind<TrackingPlugin>(TrackingPluginSymbol).toDynamicValue((c) => {
    const parameterResolver = new TinCanLaunchParametersResolver();
    const client = c.container.get(XApiClient);

    const childContainer = new IoC.Container();
    childContainer.parent = c.container;
    childContainer.load(eventHandlerModule);

    // TODO: refactor out tracking plugins
    childContainer.load(...examTinCanTrackingModules);
    childContainer.load(...sectionStateTinCanTrackingModules)
    childContainer.load(courseTinCanTrackingModule)
    childContainer.load(...badgeTinCanTrackingModules)
    childContainer.load(...interactionTinCanTrackingModules)
    childContainer.load(...questionTinCanTrackingModules)
    childContainer.load(...bookmarkTinCanTrackingModules)
    
    const handler = childContainer.get(TinCanEventHandler);

    return new TinCanTrackingPlugin({
      name: 'tincan',
      priority: 0,
      isAvailable: async () => parameterResolver.resolve().success },
                                    parameterResolver,
                                    client,
                                    handler,
                                    childContainer.get(Common.StoreCommandExecutor));
  });

});

const eventHandlerModule = new IoC.ContainerModule((bind) => {
  bind(TinCanEventHandler).toSelf();
  
  // store
  bind(Common.SuspendDataStoreSymbol).to(XApiSuspendDataStore).inSingletonScope();

  // commands
  bind(Common.StoreCommandExecutor).toSelf().inSingletonScope();
  Common.registerCommandHandlerFactory(bind);
  Common.registerQueryHandlerFactory(bind);
});
